import { opportunityConstants } from '../constants/actionTypes'

const initialState = {
  isFetching: false,
}

export function opportunity(state = initialState, action) {
  switch (action.type) {
    case opportunityConstants.CREATE_OPPORTUNITY_REQUEST:
      return {
        isFetching: true,
      }
    case opportunityConstants.CREATE_OPPORTUNITY_SUCCESS:
      return {
        isFetching: false,
        opportunityId: action.opportunityId,
        hasIndicativeProposal: action.hasIndicativeProposal,
      }
    case opportunityConstants.CREATE_OPPORTUNITY_ERROR:
      return {
        isFetching: false,
        errorMessage: action.errorMessage,
      }
    case opportunityConstants.RECEIVE_OPPORTUNITY_ID:
      return {
        isFetching: false,
        opportunityId: action.opportunityId,
        hasIndicativeProposal: action.hasIndicativeProposal,
      }
    case opportunityConstants.FETCH_OPPORTUNITY_REQUEST:
      return {
        ...state,
        isFetching: true,
      }
    case opportunityConstants.FETCH_OPPORTUNITY_INFO_SUCCESS:
      //will need to clean up data for opportunity later
      //For now just store everything
      return {
        opportunityId: action.payload.id,
        hasIndicativeProposal: action.payload.hasIndicativeProposal,
        state: action.payload.state,
        proposalNumber: action.payload.proposal.proposalNumber,
        dateOfProposalAcceptance: action.payload.proposal.acceptedOn,
        isFetching: false,
        channel: action.payload.channel,
        registrationNumber: action.payload.registrationNumber,
        currentNLOutOfPocketCostPerPay:
          action.payload.currentNLOutOfPocketCostPerPay,
        leaseEndDate: action.payload.currentLeaseEndDate,
        financeapplicationnumber: action.payload.efaNumber,
        brand: action.payload.brand,
        settlement: action.payload.settlement,
        bpFuelProvider: action.payload.bp,
        caltexFuelProvider: action.payload.caltex,
        shellFuelProvider: action.payload.shell,
      }
    case opportunityConstants.FETCH_OPPORTUNITY_ERROR:
      return {
        isFetching: false,
        opportunityId: state.opportunityId,
        hasIndicativeProposal: state.hasIndicativeProposal,
        errorMessage: action.errorMessage,
      }
    default:
      return state
  }
}
